// Copyright (c) 2025 Deere & Company

import DateCellRenderer from '../../../../sharedmodules/grid-cell-renderer/date-cell-renderer';
import classNames from '../../../../sharedmodules/constants/ag-grid-class-names';
import dateFilterParams from '../../../../sharedmodules/constants/date-filter-params';
import { translate } from '../../../../sharedmodules/services/translation-service';

export function getDuplicatePinPlateColumnDefinitions() {

    return [
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'pin',
            field: 'pin',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('PIN'),
            width: 190,
        },
        {
            cellClass: classNames.cellLeftClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'dateSubmmited',
            field: 'dateSubmmited',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerLeftClassName,
            headerName: translate('DATE_SUBMITTED'),
            width: 200,
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'machineModel',
            field: 'machineModel',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('MACHINE_MODEL_TYPE'),
            width: 200,
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'requesterTCSM',
            field: 'requesterTCSM',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('REQUESTER_TCSM'),
            width: 200,
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'missingPlateReason',
            field: 'missingPlateReason',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('REASON_FOR_MISSING_PLATE'),
            width: 200,
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'account',
            field: 'dealer.account',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('ACCOUNT'),
            width: 100,
            valueGetter: (params) => params.data?.dealer?.account ?? '',
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'mailingRecipient',
            field: 'mailingRecipient',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('RECIPIENT_DEALER_OR_TCSM'),
            width: 200,
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'address1',
            field: 'dealer.location.address1',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('ADDRESS_LINE1'),
            width: 200,
            valueGetter: (params) => params.data?.dealer?.location?.address1 ?? '',
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'address2',
            field: 'dealer.location.address2',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('ADDRESS_LINE2'),
            width: 200,
            valueGetter: (params) => params.data?.dealer?.location?.address2 ?? '',
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'city',
            field: 'dealer.location.city',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('CITY'),
            width: 200,
            valueGetter: (params) => params.data?.dealer?.location?.city ?? '',
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'state',
            field: 'dealer.location.state',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('STATE_PROVINCE'),
            width: 200,
            valueGetter: (params) => params.data?.dealer?.location?.state ?? '',
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'postalCode',
            field: 'dealer.location.postalCode',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('POSTAL_CODE'),
            width: 200,
            valueGetter: (params) => params.data?.dealer?.location?.postalCode ?? '',
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'country',
            field: 'dealer.location.country',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('COUNTRY'),
            width: 200,
            valueGetter: (params) => params.data?.dealer?.location?.country ?? '',
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'phone',
            field: 'dealer.phone',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('PHONE'),
            width: 200,
            valueGetter: (params) => params.data?.dealer?.phone ?? '',
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'instruction',
            field: 'instruction',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('SPECIAL_INSTRUCTIONS'),
            width: 200,
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'approverRemark',
            field: 'approverRemark',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('APPROVAL_REMARKS'),
            width: 200,
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'status',
            field: 'status',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('APPROVAL_STATUS'),
            width: 200,
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'factoryName',
            field: 'factoryName',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('FACTORY_NAME'),
            width: 200,
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'factory',
            field: 'factoryCode',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('FACTORY'),
            width: 200,
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'approvedBy',
            field: 'approvedBy',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('APPROVER'),
            width: 200,
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'shippingId',
            field: 'shippingId',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('SHIPPING_ID'),
            width: 200,
        },

    ];

}
